var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"poi-icon",class:`poi-icon-${_vm.iconName}`,attrs:{"viewBox":"0 0 24 24","role":"img"}},[_c('title',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('path',{attrs:{"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }